import React from 'react';
import KickImage from 'Reuseables/KickImage';
import styled from 'styled-components';
import classNames from 'classnames';
import Select from 'react-select';

class RaffleSizeDropDown extends React.Component {
  constructor(props) {
    super(props)
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
  }

  handleMouseDown (event) {
		event.preventDefault();
		event.stopPropagation();
		this.props.onSelect(this.props.option, event);
  }

  handleMouseEnter (event) {
		this.props.onFocus(this.props.option, event);
  }

  handleMouseMove (event) {
		if (this.props.isFocused) return;
		this.props.onFocus(this.props.option, event);
  }

  render() {
    const { option, className, ...otherProps } = this.props;
    return (
      <WrapperDropDown
        {...otherProps}
        className={classNames(className, "Select__raffle-picker__size--option")}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        title={this.props.option.label}
      >
        <Content>
          <p>{ option.label }</p>
        </Content>
      </WrapperDropDown>
    )
  }
}

const WrapperDropDown = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
`;

const Content = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: row;
  justify-content: center;
`;

export default RaffleSizeDropDown;
